import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './RegisterPage.css';

const RegisterPage = () => {
  const [name, setName] = useState('');
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [address, setAddress] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleRegister = async () => {
    try {
      await axios.post('https://krimaanapp-4.onrender.com/api/register', { name, id, password, address }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      // Redirect to login page after successful registration
      navigate('/login');
      alert('Farmer Registered Successfully')
    } catch (err) {
      setError('Error registering farmer');
    }
  };

  return (
    <div className="register-page" data-aos='fade-up' data-aos-duration= '1000'>
      <h1>Farmers Registration</h1>
      <input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
      <input placeholder="Farmer's Id" value={id} onChange={(e) => setId(e.target.value)} />
      <input placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      <input placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} />
      {error && <p className="error">{error}</p>}
      <button onClick={handleRegister}>Register</button>
    </div>
  );
};

export default RegisterPage;
